import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingContactUs: {
    id: 'charity.vetting.contact.us',
    defaultMessage: 'Contact us',
  },
  charityVettingHeaderStepTrackerText: {
    id: 'charity.vetting.header.step.tracker.text',
    defaultMessage: 'Section {step} of {totalSteps}',
  },
  charityVettingNavItemGetStarted: {
    id: 'charity.vetting.navigation.item.introduction',
    defaultMessage: 'Introduction',
  },
  charityVettingNavItemSearch: {
    id: 'charity.vetting.navigation.item.contact.details',
    defaultMessage: 'Contact details',
  },
  charityVettingNavItemSocialMedia: {
    id: 'charity.vetting.navigation.item.social.medie',
    defaultMessage: 'Social media',
  },
  charityVettingNavItemReviewDetails: {
    id: 'charity.vetting.navigation.item.review',
    defaultMessage: 'Review and confirm',
  },
  charityVettingNavItemOrganisationInformation: {
    id: 'charity.vetting.navigation.item.organisation.information',
    defaultMessage: 'Organisation information',
  },
  charityVettingNavItemDonationPreferences: {
    id: 'charity.vetting.navigation.item.donation.preferences',
    defaultMessage: 'Donation preferences',
  },
  charityVettingNavItemFoodHygiene: {
    id: 'charity.vetting.navigation.item.food.hygiene',
    defaultMessage: 'Food hygiene',
  },
  charityVettingNavItemFoodSafety: {
    id: 'charity.vetting.navigation.item.food.safety',
    defaultMessage: 'Food safety',
  },
  charityVettingNavItemDocuments: {
    id: 'charity.vetting.navigation.item.documents',
    defaultMessage: 'Documents',
  },
  charityVettingNavItemUnwantedFood: {
    id: 'charity.vetting.navigation.item.unwanted.food',
    defaultMessage: 'Unwanted food',
  },
});
